import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import NavbarComponent from './components/NavbarComponent';
import SidebarMenu from './components/SidebarMenu';
import BookPage from './pages/BookPage';
import ScoreboardPage from './pages/ScoreboardPage';
import LoginPage from './pages/LoginPage';
import AdminPanel from './components/AdminPanel';
import UploadsDefiCTPage from './pages/UploadsDefiCTPage';
import UploadsPatrouilleCTPage from './pages/UploadsPatrouilleCTPage';
import BrancheLoginPage from './pages/BrancheLoginPage';
import BrancheAdminPage from './pages/BrancheAdminPage';
import CTAdminPage from './pages/CTAdminPage';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { useState, useEffect } from 'react';
import { loginSuccess, logout } from './slices/authSlice';
import { selectAuth } from './slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'
import axios from 'axios';
import OneSignal from 'react-onesignal';


//useeffct to test with a get request to /login if user logged in 



function App() {
  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const dispatch = useDispatch()

  useEffect(() => {
    const fetchLogin = async () => {
      try {
        const response = await axios.get('/api/login');
        if (response.status !== 200) {
          dispatch(logout());
        }
      } catch (error) {
        dispatch(logout())
        console.error('Error during login:', error);
        // Handle error appropriately, e.g., show an error message or dispatch a failure action
      }
    };
    console.log("hereee")
    fetchLogin();
  }, [dispatch]);

  useEffect(() => {
    // Ensure this code runs only on the client side
    if (typeof window !== 'undefined') {
      OneSignal.init({
        appId: "e9588092-9bfe-4833-8be0-64c23c70bbb3",
        safari_web_id: "web.onesignal.auto.68a78e72-ca6b-43d3-aa15-83c87cfb9ced",
        notifyButton: {
          enable: true,
        },
        // Uncomment the below line to run on localhost. See: https://documentation.onesignal.com/docs/local-testing
         //allowLocalhostAsSecureOrigin: true
      });
    }
  }, []);

  return (
    <Router>
      <div className="app-container">
        <NavbarComponent />
        <Container>
          <Routes>
            <Route path="/book" element={<BookPage />} />
            <Route path="/scoreboard" element={<ScoreboardPage />} />
            <Route path="/login" element={<LoginPage />} />
            {/* <Route path="/CTAdmin" element={<CTAdminPage />} /> */}
            <Route path="/UploadsDefis" element={<UploadsDefiCTPage />} />
            <Route path="/UploadsPatrouilles" element={<UploadsPatrouilleCTPage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="/loginbranche" element={<BrancheLoginPage />} />
            <Route path="/branche" element={<BrancheAdminPage />} />
            <Route path="/" element={<BookPage />} />
          </Routes>
        </Container>
      </div>
    </Router>
  );
}



export default App;